import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { OrdersGateway } from '@domain/gateway/orders-gateway';
import { OrdersModel, OrdersServerModel } from '@domain/entities/orders.model';

@Injectable({
    providedIn: 'root',
})
export class OrdersService extends OrdersGateway {
    private endpoint = 'wp-json/wc/v3/orders';

    constructor(private _http: HttpClient) {
        super();
    }

    /**
     * @description Get orders
     * @param params (Optional)
     * @returns Observable of orders entity
     */
    read(params?: HttpParams): Observable<OrdersServerModel[]> {
        return this._http.get<OrdersServerModel[]>(
            `${environment.host}${this.endpoint}`,
            {
                params,
            }
        );
    }

    /**
     * @description Create order
     * @returns Observable of order entity
     */
    create(form: OrdersModel): Observable<OrdersServerModel> {
        return this._http.post<OrdersServerModel>(
            `${environment.host}${this.endpoint}`,
            form
        );
    }

    /**
     * @description Read a order
     * @returns Observable of order entity description
     */
    readById(id: number): Observable<OrdersServerModel> {
        return this._http.get<OrdersServerModel>(
            `${environment.host}${this.endpoint}/${id}`
        );
    }

    /**
     * @description Update order
     * @returns Observable of order entity
     */
    update(id: number, form: OrdersModel): Observable<OrdersServerModel> {
        return this._http.put<OrdersServerModel>(
            `${environment.host}${this.endpoint}/${id}`,
            form
        );
    }

    /**
     * @description Delete order
     * @returns Observable of order entity
     */
    delete(id: number): Observable<OrdersServerModel> {
        return this._http.delete<OrdersServerModel>(
            `${environment.host}${this.endpoint}/${id}?force=true`
        );
    }
}
